import React, { useState } from 'react';


import Spinner from '../compUtils/Spinner';

import ReviewExisting from '../compObjects/ReviewExisting';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'

import LazyLoad from 'react-lazyload';
import Icon from '../compUtils/Icon';

function ReviewsPage(props) {

  const [sortBy, setSortBy] = useState("-date")
  const [sortDD, setSortDD] = useState("")

  const dispatch = useDispatch()
  const objectId = "/api/reviews/?param="+encodeURI(JSON.stringify( {"order_by":sortBy} ))
  const reviewSelector = useObjectSelector(objectId)
  const reviews = getObject(objectId, reviewSelector, dispatch)

  
//<LazyLoad height={200}>
  return (

    <span >

      {
        reviews() === "UNKNOWN"
          ?
          <Spinner />
          :

          <div class="columns">

            <div class="column is-one-fifth">

              <div class={"dropdown " + sortDD}>
                <div class="dropdown-trigger">
                  <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" onClick={() => setSortDD("is-active")}>
                    <span>Ordre</span>
                    <span class="icon is-small">
                      <Icon name="angle-down" />
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <a class={"dropdown-item " + (sortBy === "-date" ? "is-active" : "")} onClick={() => { setSortBy("-date"); setSortDD("") }}>
                      Les plus récentes
                    </a>
                    <a class={"dropdown-item " + (sortBy === "-score" ? "is-active" : "")} onClick={() => { setSortBy("-score"); setSortDD("") }}>
                      Les meilleures notes
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">

              {reviews().map((review) => (
                <LazyLoad height={200}>
                <ReviewExisting reviewId={review.id} type={"PROFILE_MOVIE"} />
                </LazyLoad>
              ))}
            </div>
            <div class="column is-one-fifth"></div>
          </div>
      }


    </span>
  );
}

export default ReviewsPage;
